import { AnyAction } from "@reduxjs/toolkit";
import { OnboardingV2ProgressResponse } from "@ifgengineering/client-invest-sdk";
import { signInAsync, signOutAsync } from "../auth/auth.actions";
import { fetchOnboardingV2ProgressAPI } from "./onboardingV2.actions";

export interface OnboardingV2State {
  neverLoaded: boolean;
  loading: boolean;
  data: OnboardingV2ProgressResponse | null;
}

export const INITIAL_STATE: OnboardingV2State = {
  neverLoaded: true,
  loading: false,
  data: null,
};

const onboardingV2Reducer = (
  state = INITIAL_STATE,
  action: AnyAction
): OnboardingV2State => {
  switch (action.type) {
    case signInAsync.fulfilled.type:
    case signOutAsync.fulfilled.type:
      return {
        ...INITIAL_STATE,
      };
    case fetchOnboardingV2ProgressAPI.pending.type:
      return {
        ...state,
        loading: true,
      };
    case fetchOnboardingV2ProgressAPI.fulfilled.type:
      return {
        ...state,
        loading: false,
        neverLoaded: false,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default onboardingV2Reducer;
